<template>
  <div class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <div>
          <svg class="mx-auto h-16 w-auto" viewBox="0 0 85 23" xmlns="http://www.w3.org/2000/svg">
            <g transform="matrix(.06126 0 0 .06126 7.069 2.501)">
              <path
                  d="m164 186c21.4 0 38.7-17.3 38.7-38.7s-17.3-38.7-38.7-38.7c-20.1-2.14-59.6-15-64.2-62.7 0-21.4-17.3-38.7-38.7-38.7s-38.7 17.3-38.7 38.7 17.3 38.7 38.7 38.7c20.4 1.77 64.4 15.5 64.2 62.7 0.19 47.2-43.9 59.7-64.5 61.9-21.4 0-38.7 17.3-38.7 38.7s17.3 38.7 38.7 38.7 38.7-17.3 38.7-38.7c7.46-44.2 44.5-61 64.5-61.9"
                  fill="#053b5b" stroke="#000" stroke-width=".265px"/>
              <circle cx="-35.9" cy="147" r="38.7" fill="#f28916" fill-rule="evenodd"
                      style="paint-order:stroke fill markers"/>
            </g>
            <g transform="matrix(.1378 0 0 .1378 -80.97 -45.28)" stroke-width=".118">
              <path
                  d="m770 449c-8.25-1.77-17.5-6.22-20.4-14.6 3.66-2.14 7.34-4.24 11-6.35 4.45 7.59 15.2 11.9 22.8 6.23 7.47-8.45-5.17-14.3-11.9-16.6-8.34-3.32-17.2-9.37-17.7-19.2-1.94-10.6 6.73-21.3 17.5-21.7 8.88-1.24 19.2 1.64 23.5 10.2-1.33 3.54-6.62 5.04-9.74 7.58-3.05-4.55-12.6-9.15-16.7-2.29-3.72 10.4 10.3 12.3 16.8 16.1 8.07 3.59 15.5 11.1 14.7 20.6 0.751 10-7.81 18.4-17.4 19.8-3.9 1.16-8.36 0.636-12.4 0.354zm129 0.0547c-14.7-14.5-30.3-28-44.4-43.1-0.428 6.67 0.258 14.1 0.146 21 0.0706 7.1 0.137 14.2 0.206 21.3h-13.1c0.121-23.7-0.299-47.3 0.295-71 5.06 1.84 10.6 9.18 15.6 13.2 10 9.44 20.1 18.9 29.5 28.9 0.587-6.82-0.299-14.4-0.123-21.5-0.0809-6.84-0.158-13.7-0.237-20.5h13.1c-0.0466 23.7 0.386 47.4-0.0934 71.1 0.228 0.519-0.524 1.33-0.958 0.548zm-87.1-36.2v-35.5h14.1v70.9h-14.1v-35.5zm104-3e-3v-35.5c15.6 0.0605 31.2 0.121 46.7 0.181v11.6c-10.7 0.186-21.5-0.198-32.2 0.576-0.961 7.56-0.305 15.3-0.384 23 9.55 0.256 19.1 0.307 28.7 0.451v11.6c-9.52 0.118-19 0.235-28.6 0.353v10.6c11.3 0.118 22.6 0.235 33.9 0.353 0.0643 4.06 0.129 8.11 0.193 12.2h-48.3v-35.5z"
                  fill="#053b5b"/>
              <path
                  d="m1007 449c0-0.169-0.833-0.417-1.85-0.55-2.65-0.347-7.78-2.13-10.8-3.75-12.3-6.63-19.5-19.7-18.6-34.2 0.79-13.9 8.96-25.7 21.4-31.1 10.1-4.33 21.8-4.14 31.7 0.523 4.38 2.07 7.08 4.03 10.5 7.57 4.22 4.42 6.7 8.75 8.6 15 0.906 2.99 0.963 3.58 0.968 10.1 0 7.56-0.324 9.45-2.59 14.9-2.3 5.52-7.4 11.8-12.3 15.1-4.32 2.9-12.2 6.01-15.2 6.01-0.404 0-0.735 0.159-0.735 0.353 0 0.22-2.06 0.353-5.47 0.353-3.01 0-5.47-0.138-5.47-0.307zm11.1-13c7.03-1.7 13.4-7.94 15.5-15.3 0.972-3.31 1.36-7.82 0.956-11.1-1.2-9.77-6.59-16.9-15-19.8-2.45-0.852-3.35-0.977-7.04-0.986-3.4-8e-3 -4.72 0.142-6.7 0.765-7.12 2.24-12.8 8.33-14.9 16-0.46 1.68-0.628 3.61-0.632 7.23-4e-3 4.2 0.119 5.33 0.821 7.58 2.07 6.62 5.99 11.5 11.4 14.1 5.02 2.41 10.2 2.94 15.6 1.61zm44.5 11.8c-0.092-0.243-0.127-16.2-0.077-35.4l0.091-34.9 11.6-0.11c12.6-0.119 16 0.136 21 1.58 9.02 2.6 15.2 8.58 17.5 16.9 0.868 3.15 1.07 11 0.374 14.3-1.26 6.01-5.03 11.3-10.2 14.3-1.33 0.765-2.48 1.58-2.57 1.82-0.09 0.235 3.02 5.2 6.92 11 3.89 5.84 7.08 10.7 7.08 10.8 0 0.103-3.61 0.145-8.03 0.0925l-8.03-0.0938-2-3c-1.1-1.65-3.72-5.62-5.82-8.82l-3.82-5.82-4.54-0.099c-3.04-0.0664-4.7 0.0349-5.03 0.308-0.394 0.327-0.49 2.1-0.49 9.01v8.6h-6.89c-5.19 0-6.93-0.109-7.06-0.441zm27.3-30.4c6.39-1.81 9.36-6.09 9.36-13.5 0-8.71-4.01-13.2-12.9-14.3-4.01-0.503-8.87-0.473-9.4 0.0565-0.315 0.315-0.423 3.96-0.423 14.2 0 7.59 0.119 13.9 0.265 14.1 0.441 0.457 11-0.0517 13.1-0.628zm32.2 30.4c0.015-0.247 6.96-16.3 15.4-35.7 9.66-22.1 15.6-35.3 15.9-35.3 0.299 0 6.52 13.3 16.3 34.9 8.71 19.2 15.9 35.3 16 35.7l0.206 0.794h-7.05c-5.23 0-7.14-0.114-7.38-0.441-0.183-0.243-0.938-1.91-1.68-3.7-0.739-1.79-1.54-3.42-1.78-3.62-0.286-0.237-5.45-0.33-15-0.269l-14.6 0.0922-3.26 7.76-6.58 0.096c-5.16 0.0751-6.58 0-6.56-0.353zm40.5-20.1c0.066-0.344-1.18-3.76-2.78-7.58-1.59-3.83-3.6-9.1-4.45-11.7-0.852-2.62-1.68-4.89-1.83-5.04-0.495-0.495-0.954 0.49-2.59 5.57-0.878 2.72-2.87 8.01-4.44 11.8-1.56 3.75-2.76 7.05-2.65 7.33 0.161 0.42 1.7 0.486 9.41 0.408 8.5-0.0867 9.23-0.143 9.34-0.72z"
                  fill="#f28916"/>
            </g>
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-semibold text-secondary-500">Reset your password</h2>
      </div>

      <div class="mt-8">

        <p v-if="displayProcessingResetError"
           class="w-full mt-4 mb-4  text-red-600 text-center ">
          {{ processingResetErrorMessage }} <button class="underline" @click="$router.push({name: 'forgot-password'})">
            Forgot your password?
          </button>
        </p>


        <form @submit.prevent="handleSubmitResetPassword()">
          <div class="mt-6 space-y-6">
            <div>
              <label for="password" class="block font-medium text-black">New password</label>
              <div class="mt-1">
                <input v-model.trim="password"
                       autofocus="autofocus"
                       id="password"
                       name="password"
                       type="password"
                       autocomplete="false"
                       required="required"
                       class="appearance-none block w-full h-12 px-4 py-2  rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary"/>
              </div>
              <p v-show="displayResetError && !isValidPassword"
                 class="mt-2 text-sm text-red-600"
                 id="password-error">
                Your password must contain at least 8 characters.
              </p>
            </div>

            <div class="space-y-1">
              <label for="password-confirm" class="block font-medium text-black">Repeat your new
                password</label>
              <div class="mt-1">
                <input v-model.trim="passwordConfirm"
                       id="password-confirm"
                       name="password-confirm"
                       type="password"
                       autocomplete="false"
                       required="required"
                       class="appearance-none block w-full h-12 px-4 py-2 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary"/>
              </div>
              <p v-show="displayResetError && isValidPassword && !passwordsMatch"
                 class="mt-2 text-sm text-red-600"
                 id="password-confirm-error">
                Your password must be the same as above.
              </p>
            </div>

            <div class="pt-4">
              <button type="submit"
                      class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-white bg-secondary-500 hover:bg-secondary-light transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
                Reset your password
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
  data() {
    return {
      password: '',
      passwordConfirm: '',
      displayResetError: null,
      displayProcessingResetError: false,
      processingResetErrorMessage: null,
    }
  },

  methods: {
    async handleSubmitResetPassword() {
      if(!this.validatePassword()) {
        return;
      }

      const response = await this.$axios
          .post(this.$apiUrl + '/account/reset-password', {
            password: this.password,
            passwordConfirm: this.passwordConfirm,
            token: this.$route.params.token,
          })
          .then((response) => {
            this.$router.push('/login');
          })
          .catch((error) => {
            this.displayResetError = true;
            this.displayProcessingResetError = true;
            this.processingResetErrorMessage = error.response.data['hydra:description'];
          });
    },
    validatePassword() {
      this.displayResetError = true;
      return this.isValidPassword && this.passwordsMatch;
    }
  },

  computed: {
    isValidPassword() {
      if (this.password.length < 8) {
        return false;
      }

      return true;
    },
    passwordsMatch() {
      return this.password === this.passwordConfirm;
    }
  }
}
</script>

<style scoped>

</style>